import { cn } from '@/utils/cn';

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-lg bg-surface',
        className
      )}
    >
      <div
        className="absolute inset-0 animate-shimmer"
        style={{
          background: 'linear-gradient(90deg, rgb(var(--skeleton-base)) 25%, rgb(var(--skeleton-highlight)) 50%, rgb(var(--skeleton-base)) 75%)',
          backgroundSize: '200% 100%',
        }}
      />
    </div>
  );
}
